<template src="./OrkHomeGallery.html"></template>

<script>

import {
  SfIcon,
  SfImage,
  SfButton
} from '@storefront-ui/vue';

import icons from "@/utils/icons";

import {Navigation, Pagination} from 'swiper'

import {SwiperCore, Swiper, SwiperSlide} from 'swiper-vue2'

import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination])

import Api from "@/api/Api";
import OrkLoader from "@/components/Ork/OrkLoader";


export default {
  name: 'OrkHomeGallery',
  components: {
    OrkLoader,
    SfImage,
    SfIcon,
    SfButton,
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      index: null,
      icons: icons,
      gallery: null,
      loading: false
    };
  },

  created() {
    this.getHomeSlider()
  },
  methods: {
    getHomeSlider() {
      this.loading = true;
      Api.marketing.getHomeSlider().then((data) => {
        this.gallery = data.sliders
            .filter(s => s.enabled)
            .filter(s => s.targets && s.targets.includes("main"));
      }).finally(() => this.loading = false);
    }
  }
};
</script>


<style lang='scss' scoped src="./OrkHomeGallery.scss"></style>
